
export const Colors={
    primary: '#ff4a00',
    error:"#E30606",
    success:"#07A23E",
    purpleAi:"#7E57C4",
    yellow:"#F6B51E",
}